import { createAction } from 'redux-actions';
import { TemplateType } from '@wix/da-shared-react/pkg/Background/types';
import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';
import { reduxKey } from '../../types/customBoxTemplates';

export const fetchMoreCustomboxTemplates = createCallbackActionCreator(
  `${reduxKey}.FETCH_MORE_CUSTOMBOX_TEMPLATES`
);

export const saveCustomboxWithTemplate = createAction(
  `${reduxKey}.SAVE_CUSTOMBOX_WITH_TEMPLATE`,
  (moduleId: number, template: TemplateType) => ({ moduleId, template })
);
